import MockAdapter from 'axios-mock-adapter';
import responses from '@/mocks/responses';

export const mockAdapter = (api, method, endpoint, name, statusCode, conditions) => {
  if (process.env.VUE_APP_USE_MOCK === 'false') return false;

  // Config
  const delayResponse = 500; //ms
  const responseData = responses(method, name, statusCode, conditions);

  const mock = new MockAdapter(api, { delayResponse: delayResponse });

  switch (method) {
    case 'get':
      return mock.onGet(endpoint).reply(statusCode, responseData);
    case 'post':
      return mock.onPost(endpoint).reply(statusCode, responseData);
    case 'put':
      return mock.onPut(endpoint).reply(statusCode, responseData);
    case 'patch':
      return mock.onPatch(endpoint).reply(statusCode, responseData);
    case 'delete':
      return mock.onDelete(endpoint).reply(statusCode, responseData);
  }
};
